import React, { FC, useMemo } from 'react';
import { format } from 'date-fns';

import { fc } from 'i18n';
import { close } from 'assets/icons/close';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { FILTER_VALUES_BY_MASK, FilterValueType } from 'constants/filters';

import styles from './styles.module.css';

interface IChipProps {
  urlKey: string;
  label: string;
  value: string;
  valueType?: FilterValueType;
  removeFilter: (name: string, value: string) => () => void;
}

export const Chip: FC<IChipProps> = (props) => {
  const { urlKey, label, value, valueType, removeFilter } = props;

  const filterValue = useMemo(() => {
    if (valueType === FilterValueType.Date) {
      return format(new Date(Number(value)), 'yyyy-MM-dd');
    }

    const filterMask = FILTER_VALUES_BY_MASK[urlKey];

    return filterMask ? fc(filterMask[value]) : value;
  }, [urlKey, value]);

  return (
    <div className={styles.chip}>
      <span>{`${label}: ${filterValue}`}</span>
      <SvgWrapper width={12} height={12} details={close} color="#5f5f5f" onClick={removeFilter(urlKey, value)} />
    </div>
  );
};
